import React, {Component} from 'react';
import Method from "../Method/Method";
import Privacy from "../Privacy/Privacy";
import Parameters from "../Parameters/Parameters";
import {Tabs} from "../../customRoute";
import Action from "../Action/Action";
import Switch from "react-switch";
import { connect } from "react-redux";
import {endpointFieldChange, endpointRemove} from "../../../../store/actions/endpoints";
import {DisplayData} from "../Action/DisplayData/DisplayData";
import CreatePosts from "../Action/CreatePosts/CreatePosts";
import {DisplayTaxonomies} from "../Action/DisplayTaxonomies/DisplayTaxonomies";
import {DisplayCustomTable} from "../Action/DisplayCustomTable/DisplayCustomTable";
import EditPost from '../Action/EditPost/EditPost'
import { CreateCustomTable } from '../Action/CreateCustomTable/CreateCustomTable'
import { EditCustomTable } from '../Action/EditCustomTable/EditCustomTable'
import { DeleteCustomTable } from '../Action/DeleteCustomTable/DeleteCustomTable'
import { DisplayUsers } from '../Action/DisplayUsers/DisplayUsers';
import EditUser from '../Action/EditUser/EditUser';
import CreateUsers from '../Action/CreateUsers/CreateUsers';
import CreateTaxonomies from '../Action/CreateTaxonomies/CreateTaxonomies';
import RESTAPICall from '../Action/RESTAPICall/RESTAPICall';
import {CustomSQLQuery} from "../Action/CustomSQLQuery/CustomSQLQuery";

const sourceField = () => {
	return {
		id:           'source',
		inputType:    'select',
		source:       'valueSource',
		label:        'Source',
		sourceName:   'name',
		sourceValue:  'value',
		value:        '',
		defaultValue: 'Select a source',
	}
};

const parametersField = () => {
	return {
		id: 'parameters',
		inputType: 'select',
		label: 'Parameter',
		source: 'parameters',
		sourceName: 'name',
		sourceValue: 'name',
		value: '',
		defaultValue: 'Select a parameter',
	};
};

const newDefaultFieldGroup = () => {
	return {
		name: name,
		label: label,
		fields: [
			Endpoint.getSourceField(),
			Endpoint.getValueInputType(),
			Endpoint.getParametersField(),
		],
	};
};

const Endpoint = ({ endpoint, id, removeEndpoint, method, endpointFieldChange, action, opacity }) => {

		return (
			<div className="wrap endpointContainer" style={{opacity: opacity}}>
				<div className="leftCol">

          <div id="poststuff" className="method-box">
            <div id="slugdiv" className="postbox ">
              <h2 className="hndle ui-sortable-handle"><span>Endpoint Visibility</span></h2>
              <div className="inside">
                <p>Switch on/off this particular endpoint</p>

                <div><Switch onChange={e => endpointFieldChange( e, id, 'enabled' )} checked={endpoint.enabled}/></div>
              </div>
            </div>
          </div>

					<Method id={id}/>
					<Action id={id}/>
					<Parameters id={id}/>
					<Privacy id={id}/>
				</div>

				<div className="rightCol">

				{ action === 'display_data' ?
						<DisplayData endpoint={endpoint} id={id}/> :
						''
					}

					{ action === 'create_post' ?
						<CreatePosts endpoint={endpoint} id={id}/> :
						''
					}

					{ action === 'display_taxonomies' ?
						<DisplayTaxonomies endpoint={endpoint} id={id}/> :
						''
					}

					{ action === 'create_taxonomies' ?
						<CreateTaxonomies endpoint={endpoint} id={id}/> :
						''
					}

					{ action === 'display_users' ?
						<DisplayUsers endpoint={endpoint} id={id}/> :
						''
					}

					{ action === 'edit_users' ?
						<EditUser endpoint={endpoint} id={id}/> :
						''
					}

					{ action === 'create_users' ?
						<CreateUsers endpoint={endpoint} id={id}/> :
						''
					}

					{ action === 'display_custom_table' ?
						<DisplayCustomTable endpoint={endpoint} id={id}/> :
						''
					}

					{ action === 'edit_post' ?
						<EditPost endpoint={endpoint} id={id}/> :
						''
					}

					{ action === 'create_custom_table' ?
						<CreateCustomTable endpoint={endpoint} id={id}/> :
						''
					}

					{ action === 'edit_custom_table' ?
						<EditCustomTable endpoint={endpoint} id={id}/> :
						''
					}

					{ action === 'delete_custom_table' ?
						<DeleteCustomTable endpoint={endpoint} id={id}/> :
						''
					}

					{ action === 'rest_api_call' ?
						<RESTAPICall endpoint={endpoint} id={id}/> :
						''
					}

          { action === 'custom_sql_query' ?
            <CustomSQLQuery endpoint={endpoint} id={id}/> :
            ''
          }

					<button style={{float: 'right'}} onClick={ () => removeEndpoint( id ) } className="button-secondary">Remove Endpoint</button>
				</div>

				<div style={{clear: 'both'}}/>

				<br/>
				<br/>
				<br/>
			</div>
		);
};

const mapStateToProps = ( state, props ) => ({
	endpoint: state.settings.endpoints[props.id],
	id: props.id,
	method: props.endpoint.method,
	enabled: props.endpoint.enabled,
	action: props.endpoint.action,
	opacity: state.settings.endpoints[props.id].opacity,
});

const mapDispatchToProps = dispatch => ({
	endpointFieldChange: ( value, endpointId, field ) => dispatch( endpointFieldChange( value, endpointId, field ) ),
	removeEndpoint: ( endpointId ) => dispatch( endpointRemove( endpointId ) )
});

export default connect(mapStateToProps, mapDispatchToProps)(Endpoint);
